module.exports = __webpack_public_path__ + "static/media/chevron2_off.1156523f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chevron2_off.svg
// module id = 128
// module chunks = 0